export default __webpack_public_path__ + "static/media/spainIcon.d2c621d9.svg";